import { RouteLocationNormalized, Router } from "vue-router"
import { AuthService } from "@/services/AuthService"

function removeHash(to: RouteLocationNormalized) {
  return to.hash && !to.meta.keepHash ? { ...to, hash: "" } : true
}

export function registerAuthMiddleware(router: Router) {
  router.beforeEach(async (to: RouteLocationNormalized) => {
    if (!to.meta.skipAuth) {
      const shouldProceed = await AuthService.ensureAuthenticated()

      return shouldProceed ? removeHash(to) : "/auth-failed"
    }

    return true
  })
}
